<template>
<div class="coupon">
    <div class="coupon-header">
        <h1 class="text-center">{{ title }}</h1>
    </div>
    <div class="coupon-body">
        <p class="coupon-description shadow-text-none text-center" v-html="description"></p>
        <div class="coupon-footer">
            <div class="coupon-code">{{ code }}</div>
            <x-button class="w-full" @click="useCoupon">{{ $t('coupon_button_use') }}</x-button>
        </div>
    </div>
</div>
</template>

<script>
import XButton from '@/components/v2/XButton'
export default {
    props: {
        code: {
            type: String,
            required: true
        },

        title: {
            type: String,
            required: true
        },

        description: {
            type: String,
            required: true
        },
    },
    components: {
        XButton
    },

    methods: {
        useCoupon() {
            this.$emit('use', this.code)
        }
    },
}
</script>

<style lang="scss">
.coupon {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 30rem;
    height: auto;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 0 8px rgba(0, 0, 0, .5);

    @media screen and (max-width: 767px) {
        width: 100%;
    }

    h1 {
        margin: 0;
        font-size: 2.5rem;
        color: #fff;

        @media screen and (max-width: 767px) {
            font-size: 1.5rem;
        }
    }

    .coupon-header {
        background-color: var(--nav-color);
        width: 100%;
        height: auto;
        padding: 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .coupon-body {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 1rem;

        .coupon-description {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
        }
    }

    .coupon-footer {
        width: 100%;
        height: auto;
        padding-top: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        column-gap: .5rem;

        .coupon-code {
            flex: auto;
            width: 14rem;
            height: 40px;
            background-color: #f2f2f2;
            border: 1px dashed #000;
            padding: .5rem;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 1rem;
        }

        button {
            flex: 1;
        }
    }
}
</style>
